import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { DeleteBlob, UploadCitation } from "../../api/debate/debate";
import {
  AddCitationUserWise,
  DeleteCitationUserWise,
  GetCitationDescription,
  GetCitationUserWise,
  UpdateCitationUserWise,
  UploadCitationExecutor,
} from "../../api/library/library";
import { useUserStore, useWorkspaceStore } from "../../Context/store";

export const useUploadCitation = () => {
  return useMutation({
    mutationFn: async (Citation) => {
      return await UploadCitation(Citation);
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
export const useDeleteBlob = () => {
  return useMutation({
    mutationFn: async (Blob) => {
      return await DeleteBlob(Blob);
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUploadCitationUserWise = () => {
  const queryClient = useQueryClient();
  const {selectedWorkspace} = useWorkspaceStore();
  const {user} = useUserStore();
  return useMutation({
    mutationFn: async (Citation) => {
      return await AddCitationUserWise(Citation);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["citation"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["categories", selectedWorkspace?.workSpaceId, user?.userId],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
export const useUploadCitationContentExecutor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (Citation) => {
      return await UploadCitationExecutor(Citation);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["citation"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useDeleteCitationUserWise = () => {
  const queryClient = useQueryClient();
  // const { user } = useUserStore();
  return useMutation({
    mutationFn: async (fileName) => {
      return await  console.log('deleted')
    },
    // mutationFn: async (fileName) => {
    //   return await  deleteUserUploadFile(user?.userId, fileName)
    // },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["citation"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
}

export const useUpdateCitationUserWise = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (Citation) => {
      return await UpdateCitationUserWise(Citation);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["citation"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useGetCitationUserWise = (
  userId,
  category = "",
  search = "",
  sortby = ""
) => {
  return useQuery({
    queryKey: ["citation", userId, category, search, sortby],
    queryFn: async () => {
      return await GetCitationUserWise(userId, category, search);
    },

    select: (data) => {
      const filteredData = data?.userDatabases?.filter((citation) => {
        if (sortby !== "recent") {
          return sortby?.includes(citation?.refFileType);
        } else {
          return citation;
        }
      });
      return {
        citations: filteredData,
        userStorage: data?.totalUserStorage,
      };
    },
    enabled: !!userId && !!category,
  });
};

export const useGetCitationDescription = (url) => {
  return useQuery({
    queryKey: ["url-data", url],
    queryFn: async () => {
      return await GetCitationDescription(url);
    },
    select: (data) => data,
    enabled: !!url,
  });
};

export const useCitationRemove = () => {
  const queryClient = useQueryClient();
  const {selectedWorkspace} = useWorkspaceStore();
  const {user} = useUserStore();
  return useMutation({
    mutationFn: async (Citation) => {
      return await DeleteCitationUserWise(Citation);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["citation"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["categories", selectedWorkspace?.workSpaceId, user?.userId],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
